import { GET_TAG } from "../const";

export const getTag = (data: any) => {
    return {
        type: GET_TAG,
        payload: data,
    };
};
